import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { JoinSessionVM } from '../models/JoinSessionVM';
import { FormBuilder } from '@angular/forms';
import { CommsService } from '../../services/comms.service';
import { JoinSessionResponseVM } from '../models/JoinSessionResponseVM';
import { SessionType } from '../models/SessionType';
import { SessionStatus } from '../models/SessionStatus';

@Component({
  selector: 'home',
  templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit {

  model: JoinSessionVM = new JoinSessionVM();
  status: SessionStatus | null;
  statusMessage: string;
  isConnecting: boolean = false;

  constructor(private router: Router, private route: ActivatedRoute, private fb: FormBuilder, private commsService: CommsService) {
  }

  ngOnInit(): void {
    let sub = this.route.params
      .subscribe(params => this.autoStart(params['sid'], params['p']));
  }

  autoStart(sessionId: string, pin: string) {
    if (sessionId != null) {
      this.model.sessionId = sessionId;
    }
    if (pin != null) {
      this.model.pin = pin;
    }

    this.sessionStartClick();
  }

  sessionStartClick() {
    this.status = null;

    if (this.model.sessionId != null && this.model.pin != null) {

      this.isConnecting = true;

      this.commsService.joinSession(this.model)
        .subscribe((returnValue) => {
          //web service responded
          if (returnValue != null) {
            this.status = returnValue.status;

            switch (returnValue.status) {
              case SessionStatus.ended:
                this.statusMessage = "This session has ended.";
                this.isConnecting = false;
                break;
              case SessionStatus.notFound:
                this.statusMessage = "Session details not recognised, please try again.";
                this.isConnecting = false;
                break;
              case SessionStatus.notStarted:
                this.statusMessage = "This session has not started, please check your session time and try again.";
                this.isConnecting = false;
                break;
              case SessionStatus.started:
                this.statusMessage = "You have successfully signed in, please wait while we connect you to the session.";
                localStorage.setItem('sessionToken', returnValue.sessionToken);
                
                switch (returnValue.sessionType) {
                  case SessionType.video:
                    this.router.navigateByUrl('/device-setup/video');
                    break;
                  case SessionType.audio:
                    this.router.navigateByUrl('/device-setup/audio');
                    break;
                  case SessionType.im:
                    this.router.navigateByUrl('/im');
                    break;
                }

                break;
            }
          }
          else {
            this.status = SessionStatus.notFound;
            this.statusMessage = "Session details not recognised, please try again.";
            this.isConnecting = false;
          }
        },
          (error) => {
            this.status = SessionStatus.notFound;
            this.statusMessage = "Session details not recognised, please try again.";
            this.isConnecting = false;
          }
        );

    }
  }

  validateSession(sessionResponse: JoinSessionResponseVM) {
    localStorage.setItem('sessionToken', sessionResponse.sessionToken);

    this.commsService.validateSession()
      .subscribe((returnValue) => {
        switch (returnValue) {
          case SessionStatus.notFound:
            this.statusMessage = "Session Id not recognised, please try again.";
            this.isConnecting = false;
            break;
          case SessionStatus.notStarted:
            this.statusMessage = "This session has not started, please check your appointment time and try again.";
            this.isConnecting = false;
            break;
          case SessionStatus.started:
            this.statusMessage = "You have successfully signed in, please wait while we connect you to the session.";

          switch (sessionResponse.sessionType) {
            case SessionType.video:
              this.router.navigateByUrl('/device-setup/video');
              break;
            case SessionType.audio:
              this.router.navigateByUrl('/device-setup/audio');
              break;
            case SessionType.im:
              this.router.navigateByUrl('/im');
              break;
          }
          break;

          case SessionStatus.ended:
            this.statusMessage = "This session has ended.";
            this.isConnecting = false;
            break;
        }

        this.status = returnValue;
      },
        (error) => {
          this.status = SessionStatus.notFound;
          this.isConnecting = false;
        }
      );

  }

}
